<script setup>
const route = useRoute()
const router = useRouter()
const { $get } = useAxios()

const { data: documents, pending: isLoaded } = useAsyncData('get all documents', () => $get('/api/v3/documents'))

const selectedDocumentSlug = computed(() =>
  route.params.slug ? route.params.slug : ''
)

const selectedDocument = computed(() => {
  return documents.value?.find((document) => {
    return document.slug === selectedDocumentSlug.value
  })
})

watch(selectedDocument, () => {
  if (selectedDocument.value)
    router.push(`/documents/${selectedDocument.value.slug}`)
})

watch(documents, () => {
  if (documents.value && !selectedDocument.value)
    router.push(`/documents/${documents.value[0].slug}`)
})

useHead(computed(() => ({
  title: 'РУСДРАМ',
  meta: [
    {
      hid: 'title',
      property: 'title',
      content: 'РУСДРАМ'
    },
    {
      hid: 'og:title',
      property: 'og:title',
      content: 'РУСДРАМ'
    },
    {
      hid: 'description',
      name: 'description',
      content:
        'Документы | Государственный русский театр драмы им. Ф. А. Искандера'
    },
    {
      hid: 'og:description',
      property: 'og:description',
      content:
        'Документы | Государственный русский театр драмы им. Ф. А. Искандера'
    },
    {
      hid: 'url',
      name: 'url',
      content: `https://rusdram.org${route.fullPath}`
    },
    {
      hid: 'og:url',
      property: 'og:url',
      content: `https://rusdram.org${route.fullPath}`
    },
    {
      hid: 'image',
      name: 'image',
      content: 'https://rusdram.org/rusdram.jpg'
    },
    {
      name: 'og:image',
      property: 'og:image',
      content: 'https://rusdram.org/rusdram.jpg'
    }
  ]
})))
</script>

<template>
<div v-if="!isLoaded">
 <div v-if="documents">
    <r-section title="Документы">
      <div class="grid grid-cols-12 gap-7">
        <div class="col-start-1 col-end-13 xl:col-end-4 flex flex-col space-y-5">
          <nuxt-link
            v-for="document in documents"
            :key="document._id"
            :to="`/documents/${document.slug}`"
            class="text-left text-primary hover:font-semibold focus:outline-none active:font-semibold"
            :class="[
              document.slug === selectedDocumentSlug ? 'font-semibold' : ''
            ]"
          >{{ document.title }}</nuxt-link>
        </div>
        <div
          v-if="selectedDocument"
          class="col-start-1 xl:col-start-4 col-end-13 v-html"
          v-html="selectedDocument.text"
        ></div>
      </div>
    </r-section>
  </div>
</div>
 <r-full-page-pro-loader v-else></r-full-page-pro-loader>
</template>
